








import { Prop, Component, Vue } from "vue-property-decorator";
import InvoiceRow from "./InvoiceRow.vue";
import VTh from "./VTh.vue";

@Component({
  components: {
    VTh,
    InvoiceRow
  }
})
export default class InvoiceHeader extends Vue {
  @Prop({ required: true }) fields!: string[];
}
